// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-quinn-residences -> quinn-residences-websites -> quinn-residences-at-mccart-landing
// Generated: 2026-10-30T17:28:07.511Z
// Counts: 0 design, 26 content, 54 slot group, 0 collection binding, 6 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose the layout that fits your day </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "easy-fee-guide-hero.lead": {
    "overrideType": "VALUE",
    "customValue": "<p>A simple breakdown of the fees, services, and optional costs associated with living at <span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "easy-fee-guide-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Know your costs before you move in.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "engrain-sitemap.height": {
    "overrideType": "VALUE",
    "customValue": "1000",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.lead": {
    "overrideType": "VALUE",
    "customValue": "<p>Compare layouts, check availability, and find the space that fits how home needs to work.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "nextstep.title": {
    "overrideType": "VALUE",
    "customValue": "<p>See townhome living in person</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourquestions.when_a": {
    "overrideType": "VALUE",
    "customValue": "<p>The scheduler shows the times you can book.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.widget.self_guided_tour_link": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_self_guided_tour_url"
  },
  "tourscheduler.widget.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.widget.use_leads_tour_times": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Inside, each four-bedroom home comes with smart-home technology, granite countertops, stainless steel appliances, an in-home washer and dryer, and an EV charger-ready garage. Outside your door are the pool, tennis courts, clubhouse, and pavilion, so you can see everything on the <a href=\"/amenities\">amenities page</a>.</p>",
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Pool days, tennis, and room to spread out</p>",
    "mappedField": null
  },
  "amenityhighlights.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>At McCart Landing, the shared spaces are just a short walk from home. Swim laps at the pool, play a set on the tennis courts, or meet up with neighbors at the clubhouse and the covered pavilion.</p>",
    "mappedField": null
  },
  "feetable.concierge_note": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Includes bi-annual filter changes, exterior pest control, 24-hour maintenance response for emergencies, and positive credit reporting.</p>",
    "mappedField": null
  },
  "floorplanshero.offer_label": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Move-in savings on select homes</p>",
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Brand-new four-bedroom rental homes in Conyers, GA</p>",
    "mappedField": null
  },
  "interactivemapcallout.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Find your open home, street by street.</p>",
    "mappedField": null
  },
  "lifestylehighlights.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>At Quinn Residences at McCart Landing, the shared spaces fit around a regular week: laps in the pool after work, a weekend match on the tennis courts, and a get-together under the pavilion. When you need room beyond your own backyard, the clubhouse is right in the neighborhood. <a href=\"/amenities\">See all amenities</a>.</p>",
    "mappedField": null
  },
  "neighborhoodcallout.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>From Grand Prix Drive, you can reach festivals and trails at the old Olympic equestrian grounds, drive a few minutes to dinner in Olde Town Conyers, or get on I-20 to head into east-metro Atlanta. Learn more about the area on our <a href=\"/neighborhood\">neighborhood page</a>.</p>",
    "mappedField": null
  },
  "neighborhoodcallout.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Next door to the Georgia International Horse Park</p>",
    "mappedField": null
  },
  "petpolicy.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Cats and dogs get space of their own here, with private backyards, professionally kept lawns and quiet residential streets for daily walks. When you want to go farther, the Rockdale River Trail and nearby Conyers parks are a short drive away. See the full <a href=\"/pet-policy\">pet policy</a> for details.</p>",
    "mappedField": null
  },
  "petpolicy.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Room to roam for cats and dogs</p>",
    "mappedField": null
  },
  "touroptions.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Walk through the Roberta, Spencer, Xavier and Sanford homes in 3D on our <a href=\"/virtual-tours\">virtual tours</a>, then see one in person on a <a href=\"/schedule-a-tour\">self-guided tour</a> or with our leasing team.</p>",
    "mappedField": null
  },
  "virtualtourembed.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Step inside all four of our four-bedroom <a href=\"/floor-plans\">floor plans</a> (the Roberta, Spencer, Xavier and Sanford, from 2,108 to 2,254 sq ft) with 3D walkthroughs, so just pick a home and look around at your own pace.</p>",
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactdetails.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "mappedField": "",
        "customValue": "/thank-you"
      }
    }
  },
  "floorplanshero.link_fees": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/easy-fee-guide"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "floorplanshero.link_pets": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/pet-policy"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "whyquinn.pillar_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Easy access to great schools, shopping, dining, and everyday essentials."
      }
    }
  },
  "whyquinn.pillar_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Spacious layouts that blend functionality, comfort, and modern style."
      }
    }
  },
  "whyquinn.pillar_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Community-Focused Amenities"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Shared spaces designed to bring neighbors together and create lasting memories."
      }
    }
  },
  "whyquinn.pillar_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Dedicated support and personalized service for a hassle-free rental experience."
      }
    }
  },
  "whyquinn.pillar_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Energy-efficient homes built to reduce environmental impact and help lower your utility costs."
      }
    }
  },
  "amenitieslist.amenity_photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Tennis Court"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167651/01a11693-d935-70e7-87aa-fd9a6ff805fd.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Two tennis courts with blue playing surfaces and green out-of-bounds areas, fenced in, with lighting."
      }
    }
  },
  "amenitieslist.amenity_photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Pool"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec37-1df2-7114-b991-7b3a372fb293.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Community swimming pool beside the tennis courts at Quinn Residences at McCart Landing"
      }
    }
  },
  "amenitieslist.amenity_photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Clubhouse"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec37-1cba-721d-adaf-4e3e713cf642.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Brick clubhouse with an arched entryway and green landscaping"
      }
    }
  },
  "amenitieslist.amenity_photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Washer/Dryer"
      }
    }
  },
  "amenitieslist.amenity_photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Large Closets"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167651/01a11693-cdc5-73a1-aa25-f6c200920d50.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Primary bath with double vanity opening into a walk-in closet"
      }
    }
  },
  "amenitieslist.amenity_photo_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Electronic Thermostat"
      }
    }
  },
  "amenitieslist.amenity_photo_7": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Pavilion"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec37-21be-755f-bb95-8aca5009ba69.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Covered pavilion with tables and chairs next to the community pool"
      }
    }
  },
  "amenitieslist.amenity_photo_8": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Private Backyard"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167651/019fec36-2660-77ac-9369-1c06e7dc2ead.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of new construction homes with manicured lawns and trees."
      }
    }
  },
  "amenitieslist.amenity_photo_9": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "EV Charger-Ready Garages"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167651/01a11693-db8b-715e-88ef-cff1bd9c8f73.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Two-story brick home with a white attached garage door and gray shutters"
      }
    }
  },
  "amenitieslist.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167651/01a11693-e775-7758-9ef6-24705aea0d46.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of the community swimming pool and tennis courts at Quinn Residences at McCart Landing"
      }
    }
  },
  "amenitygroups.community_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167651/01a11693-9430-707f-ac41-46da4fc1c92a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a swimming pool and tennis courts at a multifamily property."
      }
    }
  },
  "amenitygroups.home_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167651/01a11693-d5c1-75fb-89f3-d698cebb84db.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen with stainless steel appliances and an island, open to a spacious living area with stairs."
      }
    }
  },
  "amenityhighlights.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec37-1df2-7114-b991-7b3a372fb293.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Community swimming pool beside the tennis courts at McCart Landing"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Pool"
      }
    }
  },
  "amenityhighlights.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167651/01a11693-d935-70e7-87aa-fd9a6ff805fd.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Two tennis courts with blue playing surfaces and green out-of-bounds areas, fenced in, with lighting."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Tennis Courts"
      }
    }
  },
  "amenityhighlights.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec37-21be-755f-bb95-8aca5009ba69.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Covered pavilion patio with tables and chairs next to the community pool"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Pavilion"
      }
    }
  },
  "amenityhighlights.card_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec37-1cba-721d-adaf-4e3e713cf642.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Brick clubhouse with an arched entryway, green landscaping and mature trees"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Clubhouse"
      }
    }
  },
  "amenityhighlights.card_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167651/01a11693-eba0-7027-a797-598f7bd4b6bc.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a residential neighborhood surrounded by trees, showcasing winding roads and houses."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Wooded Grounds"
      }
    }
  },
  "amenityhighlights.card_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167651/01a11693-d5c7-757e-9e49-4aa4cfad45c8.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Two-story brick home at McCart Landing with an attached two-car garage and a manicured lawn"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Two-Car Garage"
      }
    }
  },
  "floorplanshero.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec37-34ec-727f-bc99-0a3b6884df85.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Two-story brick rental home with a two-car garage at McCart Landing"
      }
    }
  },
  "floorplanshero.photo_10": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167651/01a11693-c5a7-76fe-89be-c374a9071724.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen with gray cabinets, granite countertops and a walk-in pantry"
      }
    }
  },
  "floorplanshero.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167651/01a11693-d2f1-701f-9847-b8b6af6b9a42.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Open-concept living area and kitchen with high ceilings and a ceiling fan"
      }
    }
  },
  "floorplanshero.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec37-1df2-7114-b991-7b3a372fb293.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Community swimming pool beside the tennis courts"
      }
    }
  },
  "floorplanshero.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec37-413a-733d-b735-78e1f2a72d54.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen with white cabinets, granite countertops and a center island"
      }
    }
  },
  "floorplanshero.photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec37-21be-755f-bb95-8aca5009ba69.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Covered poolside patio with tables and chairs"
      }
    }
  },
  "floorplanshero.photo_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167651/01a11693-d5c1-75fb-89f3-d698cebb84db.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen with stainless steel appliances and island open to the living area and stairs"
      }
    }
  },
  "floorplanshero.photo_7": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167651/01a11693-e3ee-7045-9747-c66c50375170.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of McCart Landing's winding streets surrounded by green trees"
      }
    }
  },
  "floorplanshero.photo_8": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167651/01a11693-df28-742a-9265-01c8f17d3469.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bright living area with light wood-look flooring and a ceiling fan"
      }
    }
  },
  "floorplanshero.photo_9": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167651/01a11693-d5c7-757e-9e49-4aa4cfad45c8.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Brick home with a two-car garage and manicured front lawn"
      }
    }
  },
  "lifestylehighlights.highlight_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Poolside downtime"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Spend warm Conyers afternoons at the community pool, then head home to your own private backyard for a quiet evening."
      }
    }
  },
  "lifestylehighlights.highlight_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Meet the neighbors"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "The pavilion is easy to use for a neighborhood get-together, and the tennis courts nearby are good for a friendly weekend match."
      }
    }
  },
  "lifestylehighlights.highlight_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Room to focus"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Turn a fourth bedroom into a home office, or walk over to the community clubhouse when you want a change of scene."
      }
    }
  },
  "neighborhoodcallout.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec35-8c8e-7456-9c58-baaf295649a7.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Georgia International Horse Park grounds in Conyers, GA"
      },
      "caption": {
        "type": "GENERATOR",
        "generatedValue": "Georgia International Horse Park"
      }
    }
  },
  "petpolicy.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec37-0e34-71a3-bb10-13257d128633.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Quiet residential street lined with new homes and green lawns at McCart Landing"
      },
      "caption": {
        "type": "GENERATOR",
        "generatedValue": "Streets made for walks"
      }
    }
  },
  "propertyoverview.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167651/01a11693-d5c7-757e-9e49-4aa4cfad45c8.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior of a two-story brick house with a two-car garage and manicured lawn."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Detached Brick Homes"
      }
    }
  },
  "propertyoverview.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167651/01a11693-c68a-740b-996a-6e5aa05aa8bd.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern open-concept living area with a kitchen island and stainless steel appliances."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Open-Concept Living"
      }
    }
  },
  "propertyoverview.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167651/01a11693-c795-7608-b527-3b955b0a79bc.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor covered patio with tables and chairs near a swimming pool."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Poolside Pavilion"
      }
    }
  },
  "propertyoverview.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167651/01a11693-d681-721c-bafe-77c645db078a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances including a refrigerator, stove, and microwave."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Granite Kitchen"
      }
    }
  },
  "propertyoverview.photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167651/01a11693-e508-729c-a977-1c17ab39b37d.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a street lined with new construction homes in a suburban neighborhood."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "McCart Landing Streets"
      }
    }
  },
  "propertyoverview.photo_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167651/01a11693-df28-742a-9265-01c8f17d3469.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Spacious living area with light wood-look flooring, neutral walls, and a ceiling fan."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Bright Living Room"
      }
    }
  },
  "reviewthemes.chip_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Helpful leasing team"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "incredibly helpful and kind"
      }
    }
  },
  "reviewthemes.chip_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Smooth move-in"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "smooth and stress-free from beginning to end"
      }
    }
  },
  "reviewthemes.chip_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Quiet homes"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "the house is clean and quiet"
      }
    }
  },
  "reviewthemes.chip_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Patient answers"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "answered all of my questions"
      }
    }
  },
  "reviewthemes.chip_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Well-kept community"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "It is well upkept"
      }
    }
  },
  "reviewthemes.chip_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Quick response"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "service requests are handled almost immediately"
      }
    }
  },
  "tourhero.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167651/019fec37-34ec-727f-bc99-0a3b6884df85.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Two-story brick home with a two-car garage, driveway and green lawn"
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "perq-floor-plan",
      "blockId": "perq-floor-plan",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
